/**
 * Pointer handlers for a web hover look that only a mouse can trigger. A tap
 * on a touch screen fires pointerenter too, and without a matching leave the
 * hover look would stay stuck after the tap.
 */

/// <reference lib="dom" />

import type { PointerEvent } from 'react';

export interface MouseHoverHandlers {
  onPointerEnter: (event: PointerEvent) => void;
  onPointerLeave: () => void;
}

export function mouseHoverHandlers(setOver: (over: boolean) => void): MouseHoverHandlers {
  return {
    onPointerEnter: (event) => {
      if (event.pointerType === 'mouse') setOver(true);
    },
    onPointerLeave: () => setOver(false),
  };
}
